import { useCallback } from "react";

import { ILocalCart } from "@swiggy-private/portal-dineout-context";

import { CART_NATIVE_BRIDGE_FLOW_TYPE } from "../../../constants";
import { useIsV2InApp } from "../../../hooks";
import { getBridgeSdk } from "../../../utils";

export const useNativeCartSync = () => {
    const sdk = getBridgeSdk();
    const { isV2InApp } = useIsV2InApp();

    const updateLocalCartInNative = useCallback(
        (cartData: ILocalCart) => {
            if (isV2InApp) {
                sdk.dineoutUpdateLocalCart({
                    flowType: CART_NATIVE_BRIDGE_FLOW_TYPE,
                    items: cartData.cartItems,
                    ...cartData,
                });
            }
        },
        [isV2InApp, sdk],
    );

    const clearLocalCartInNative = useCallback(() => {
        if (isV2InApp) {
            sdk.dineoutClearLocalCart({ flowType: CART_NATIVE_BRIDGE_FLOW_TYPE });
        }
    }, [isV2InApp, sdk]);

    const refreshMenuInNative = useCallback(() => {
        if (isV2InApp) {
            sdk.dmRefreshMenu({ refresh: true });
        }
    }, [isV2InApp, sdk]);

    return { updateLocalCartInNative, clearLocalCartInNative, refreshMenuInNative };
};
